export var SnowflakeAuthType;
(function (SnowflakeAuthType) {
    SnowflakeAuthType["Basic"] = "Basic";
    SnowflakeAuthType["PrivateKey"] = "Private Key";
    SnowflakeAuthType["PrivateKeyWithPassphrase"] = "Private Key With Passphrase";
})(SnowflakeAuthType || (SnowflakeAuthType = {}));
//# sourceMappingURL=snowflake-auth-type.js.map